import SponsorshipsSection from '#app/components/sponsorship-section.tsx';
import { type Route } from './+types/partnerships.ts'

export const meta: Route.MetaFunction = () => {
	var title = "JaseOwns.com - Partnership";
	var description = "JaseOwns.com is the online dumping ground of Jason Ramsey and includes ramblings of an internet ⭐ star. He's a streamer, dreamer, developer, gamer, husband and father who has been a nerd owning people on the internet since dial up 🖥️☎️.  If you're interested in partnering with me, please reach out me.";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/jase.gif"},
		{ property: "og:image:alt", content: "JaseOwns Blinking"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

export default function PartnershipRoute() {
	return (
		<main className="container mx-auto font-light text-black dark:text-white">
			<SponsorshipsSection />
		</main>
	)
}

